import React from 'react'

import FileUploadArea from './FileUploadArea.jsx'
import RequestTaskFileRow from './RequestTaskFileRow.jsx'
import { formatDate } from '../utils/documentUtils.js'
import DocumentsHeader from './DocumentsHeader.jsx'

const NoDocumentsTask = ({
  selectedFirm,
  requestTask,
  unmatchedFiles = [],
  files,
  dragOver,
  setDragOver,
  onFileUpload,
  onDrop,
  onRemoveFile,
  submitting,
  onSubmitFiles,
  onFinishTask,
  onDeleteFile,
  isMatchingFiles,
  uploadItems,
  isSaving,
}) => {
  const hasUnmatched = unmatchedFiles && unmatchedFiles.length > 0
  return (
    <div className="tw-mx-auto tw-max-w-[900px] tw-p-8">
      <DocumentsHeader
        selectedFirm={selectedFirm}
        requestTask={requestTask}
        documents={[]}
        unmatchedFiles={unmatchedFiles}
        onFinishTask={onFinishTask}
        isSaving={isSaving}
      />

      <div className="tw-mb-4 tw-mt-8 tw-flex tw-items-center tw-justify-between tw-gap-4">
        <h3 className="tw-m-0">Requested Documents</h3>
        {requestTask.documents_range_to_date && (
          <p className="tw-mb-0 tw-shrink-0 tw-text-sm">
            <strong>From:</strong>{' '}
            {formatDate(requestTask.documents_range_from_date)} |{' '}
            <strong>To:</strong>{' '}
            {formatDate(requestTask.documents_range_to_date)}
          </p>
        )}
      </div>

      {hasUnmatched &&
        unmatchedFiles.map(file => (
          <RequestTaskFileRow
            key={file._id}
            file={file}
            onDelete={() => onDeleteFile(file._id, 'unmatched')}
          />
        ))}

      {/* File upload area */}
      <FileUploadArea
        files={files}
        dragOver={dragOver}
        setDragOver={setDragOver}
        onFileUpload={onFileUpload}
        onDrop={onDrop}
        onRemoveFile={onRemoveFile}
        submitting={submitting}
        onSubmitFiles={onSubmitFiles}
        hasDocuments={false}
        isMatchingFiles={isMatchingFiles}
        uploadItems={uploadItems}
      />
    </div>
  )
}

export default NoDocumentsTask
